import { useContext } from "react";

import { TitleOverrideContext } from "../../context/sectionTabs/TitleOverrideContext";
import type { TitleOverrideContextValue } from "../../context/sectionTabs/types";

const noop = () => {};

/**
 * No-op fallback when consumed outside a MobileSectionTabsProvider.
 */
const FALLBACK_CONTEXT: TitleOverrideContextValue = {
  titleOverride: null,
  setTitleOverride: noop,
};

/**
 * Register/read the mobile shell's default-TopBar title override.
 */
export const useMobileTitleOverride = () => {
  const context = useContext(TitleOverrideContext);
  if (!context && process.env.NODE_ENV === "development") {
    console.warn(
      "useMobileTitleOverride: called outside MobileSectionTabsProvider, using noop fallback. " +
        "This is expected for pages on the legacy app shell path.",
    );
  }
  return context ?? FALLBACK_CONTEXT;
};
